/** Shared audio checks for call recording upload UI + create flow */

export const ACCEPT_AUDIO = 'audio/*,.mp3,.wav,.m4a,.ogg,.webm,audio/mpeg';

export const isAudioFile = (f) => {
  if (!f) return false;
  const type = (f.type || '').toLowerCase();
  if (type.startsWith('audio/')) return true;
  const name = (f.name || '').toLowerCase();
  return /\.(mp3|wav|m4a|ogg|webm|aac|flac)$/.test(name);
};
